import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsPaternFill from 'highcharts/modules/pattern-fill';
import { CHART_COLOR_PALLETTE } from 'utils/constants';

HighchartsPaternFill(Highcharts);

export interface IData {
  name: string;
  value: string;
  spend: string;
  isOther?: boolean;
  color?: any;
  y: number;
}

interface IProps {
  data: IData[];
}

export const PieChart: React.FC<IProps> = ({ data }) => {
  const getOptions = () => {
    return {
      chart: {
        type: 'pie',
        backgroundColor: 'transparent',
        style: { fontFamily: 'Roboto' },
        width: 550,
        height: 432,
      },
      credits: { enabled: false },
      exporting: { enabled: false },
      title: { text: '' },
      series: [
        {
          innerSize: 155,
          size: 280,
          data,
        },
      ],
      plotOptions: {
        pie: {
          dataLabels: {
            connectorWidth: 1,
            connectorColor: CHART_COLOR_PALLETTE[1],
            connectorShape: 'straight',
            distance: 20,
          },
          borderWidth: 3,
        },
        series: {
          dataGrouping: {
            enabled: false,
          },
          animation: { duration: 400 },
          states: {
            inactive: { enabled: false },
            hover: {
              animation: { duration: 20 },
              halo: {
                size: 0,
              },
            },
          },
        },
      },
      tooltip: { enabled: false },
    };
  };

  return <HighchartsReact highcharts={Highcharts} options={getOptions()} />;
};
